import AbstractBandsCalculator from "./abstract-bands-calculator";

export default class TaxCalculator extends AbstractBandsCalculator {
    constructor(allowancesCalculator, salary, bands) {
        super(salary, bands);
        this.allowancesCalculator = allowancesCalculator;
    }

    calculate() {
        let tax = 0;
        tax += this.calculateBand('basic');
        tax += this.calculateBand('higher');
        tax += this.calculateBand('additional');
        tax -= this.allowancesCalculator.calculateMarriedCouplesAllowance();
        return tax;
    }

    calculateTaxable() {
        const grossIncome = this.salary.getGross('year');
        const personalAllowance = this.allowancesCalculator.calculate();
        const taxable = grossIncome - personalAllowance;
        return taxable > 0 ? taxable : 0.0;
    }

    getDeductableIncome() {
        return this.calculateTaxable();
    }
}